import * as React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SearchInput,
  ImageField,
  BooleanField,
  NumberField,
} from 'react-admin';

const filters = [<SearchInput source='name' alwaysOn />];

export default function ResourceList(props: any) {
  return (
    <List {...props} filters={filters}>
      <Datagrid rowClick='edit'>
        <NumberField source='id' />
        <TextField source='language.name' />
        <TextField source='key' />
        <TextField source='category.name' />
        <TextField source='product.name' />
        <TextField source='value' />
      </Datagrid>
    </List>
  );
}
